import styled, {css} from "styled-components"
import {Card, Col} from "@irati/ui/src/Layout"

const MobileFlushCol = styled(Col)`
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.tablet`
      padding-left: 0;
      padding-right: 0;
      ${Card} {
        border-radius: 0;
      }
    `}
  `}
`

export default MobileFlushCol
